import { makeStyles, } from '@mui/styles';

export const useStyles = makeStyles(() => (
  {
    marginBottom: {
      marginBottom: 15,
    },
    containerWidth: {
      width: '100%',
    },
    saveButton: {
      marginTop: 5,
      float: 'right',
    },
  })
);
